/** Тег кешу «Моєї роботи» (GET /me/work): його інвалідовує кожна зміна запису — призначення, статус чи термін могли змінитися. */
export const myWorkTag = { type: 'Me' as const, id: 'work' };
